import { render, staticRenderFns } from "./contract-agentnew.vue?vue&type=template&id=06558efa&scoped=true"
import script from "./contract-agentnew.vue?vue&type=script&lang=js"
export * from "./contract-agentnew.vue?vue&type=script&lang=js"
import style0 from "./contract-agentnew.vue?vue&type=style&index=0&id=06558efa&prod&lang=css"
import style1 from "./contract-agentnew.vue?vue&type=style&index=1&id=06558efa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06558efa",
  null
  
)

export default component.exports